export default "__VITE_ASSET__rpTIIhPG__"